import { registerDecorators as _registerDecorators, LightningElement, registerComponent as _registerComponent } from "lwc";
import _tmpl from "./footer.html";
import { APPX_JP_SITE_URL, APPX_SITE_URL } from '~/modules/config';
import { getUserLanguage } from '~/modules/helpers/languageHelper';
import { WireI18n, selectSharedLabels } from '~/modules/stores/i18nStore';
import { images } from '~/modules/utilities/assetUtilities';
import { JAPANESE_LANGUAGE_CODE } from '~/modules/utilities/language_utils';
class Footer extends LightningElement {
  constructor(...args) {
    super(...args);
    this.footerLinks = null;
    this.footerLabels = null;
    this.imageUrl = images.cookiePreferences;
    this.labels = void 0;
    // @ts-expect-error * Automated Type Error Fix
    this.handleClickOnCookiePreferences = event => {
      event.preventDefault();
      window.OneTrust?.ToggleInfoDisplay();
    };
    // @ts-expect-error * Automated Type Error Fix
    this.handleClickPrivacyChoices = event => {
      event.preventDefault();
      window.location.href = 'https://www.salesforce.com/form/other/privacy-request/';
    };
  }
  i18nConnectedCallback(i18n) {
    this.footerLabels = i18n.footer;
    this.footerLinks = i18n.footer.links;
  }
  get twitterIcon() {
    return this.labels.twitterIconLabel;
  }
  get linkedInIcon() {
    return this.labels.LinkedInIconLabel;
  }
  get isJapaneseUserLanguage() {
    return getUserLanguage() === JAPANESE_LANGUAGE_CODE;
  }
  get appxSiteUrlLabel() {
    if (this.isJapaneseUserLanguage) {
      return this.footerLabels?.goToEnglishPage;
    }
    return this.footerLabels?.goToJapanesePage;
  }
  get appxSiteUrl() {
    if (this.isJapaneseUserLanguage) {
      return APPX_SITE_URL;
    }
    return APPX_JP_SITE_URL;
  }
  /*LWC compiler v7.1.3*/
}
_registerDecorators(Footer, {
  wire: {
    i18nConnectedCallback: {
      adapter: WireI18n,
      method: 1,
      config: function ($cmp) {
        return {};
      }
    },
    labels: {
      adapter: WireI18n,
      dynamic: [],
      config: function ($cmp) {
        return {
          selector: selectSharedLabels
        };
      }
    }
  },
  fields: ["footerLinks", "footerLabels", "imageUrl", "handleClickOnCookiePreferences", "handleClickPrivacyChoices"]
});
const __lwc_component_class_internal = _registerComponent(Footer, {
  tmpl: _tmpl,
  sel: "",
  apiVersion: 62
});
export default __lwc_component_class_internal;